/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import clsx from "clsx"

import { getRiskClassName } from "../components/risk-score"

import styles from "./risk-flag.module.css"

interface Props {
    /**
     * Flag as the API reports it, such as `ROOTED`.
     */
    name: string | undefined
    /**
     * How much the flag adds to the device's risk score, which picks its band.
     */
    score: number | undefined
}

/**
 * A device flag and its score, on the colour of the band the score falls in.
 *
 * The band classes come from `RiskScore`'s scale through `getRiskClassName`, so
 * the flag and the score always agree on a band's colour.
 *
 * @example
 * <RiskFlag name={flag.name} score={flag.score} />
 */
export const RiskFlag = ({ name, score }: Props) => (
    <span className={clsx(styles.flag, getRiskClassName(score))}>
        {name}: {score}
    </span>
)
